import {
  AnyDatesCantBeInThePastRule,
  StartDateRequiredRule,
} from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Workflow/Rules';
import { useWorkflowForm } from '../../../../contexts/CampaignWorkflowFormContext';
import { useSchedulingSelector } from '../../../../state/SplitTests/selectors/useSchedulingSelector';

export const useShowValidationWarning = ({ splitTestId }: { splitTestId: string }) => {
  const { state: formState } = useWorkflowForm();
  const { startDate, endDate } = useSchedulingSelector({ splitTestId }) ?? {};

  const failedValidation =
    StartDateRequiredRule({ startDate }).result === 'fail' ||
    AnyDatesCantBeInThePastRule({ startDate, endDate }).result === 'fail';

  const hasFocusedAndClosedDrawer = formState.touched[splitTestId] && !formState.focused[splitTestId];

  return failedValidation && hasFocusedAndClosedDrawer;
};
